module.exports = __webpack_public_path__ + "img/shield-exclamation.b37712b4.svg";